import axios from 'axios';
import { PAYMENT_URI } from './apiVersionConstants';

export default {
    async removeAutoPay(contractId) {
        return axios.get(`${PAYMENT_URI}/RemoveAutopay/${contractId}`);
    },
};